var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('span',{class:[
        'icon',
        _vm.iconColor,
        ( _obj = {}, _obj[("icon-" + _vm.size)] = _vm.size, _obj ),
        ( _obj$1 = {}, _obj$1[("icon-" + _vm.icon)] = _vm.icon, _obj$1 )
    ]},[_c('svg',{class:['svg-icon', _vm.customClass, { 'svg-inline': _vm.inline }],attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',_vm._b({},'use',{ 'xlink:href': '/vue/feather-sprite.svg#' + _vm.icon },false))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }